import { render, staticRenderFns } from "./favorites_setting_items.vue?vue&type=template&id=20bd1416&scoped=true&"
import script from "./favorites_setting_items.vue?vue&type=script&lang=js&"
export * from "./favorites_setting_items.vue?vue&type=script&lang=js&"
import style0 from "./favorites_setting_items.vue?vue&type=style&index=0&id=20bd1416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bd1416",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('20bd1416', component.options)
    } else {
      api.reload('20bd1416', component.options)
    }
    module.hot.accept("./favorites_setting_items.vue?vue&type=template&id=20bd1416&scoped=true&", function () {
      api.rerender('20bd1416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/favorites/favorites_setting_items.vue"
export default component.exports